import parse from 'html-react-parser';
import { FunctionComponent, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Dialog, DialogContent } from '@material-ui/core';

import { findCmsRecordByKey } from '@/applications/CspPortal/Brands/utils';
import { selectDynamicContent } from '@/applications/CspPortal/CSP-Form/selectors';
import { UsecaseType } from '@/utils/types';

interface UseCaseAlertModalProps {
  open?: boolean;
  useCase?: UsecaseType;
  onClose?: () => void;
  onSubmit?: () => void;
}

const UseCaseAlertModal: FunctionComponent<UseCaseAlertModalProps> = ({
  open = false,
  useCase,
  onClose,
  onSubmit,
}) => {
  const dynamicContent = useSelector(selectDynamicContent);
  const emergencyAlertText = useMemo(
    () =>
      findCmsRecordByKey(
        dynamicContent,
        'csp-campaign-register-form#emergency-alert'
      )?.text || '',
    [dynamicContent]
  );
  const isCarrierExempt = useMemo(
    () => useCase?.id === 'CARRIER_EXEMPT',
    [useCase]
  );
  const isEmergency = useMemo(() => useCase?.id === 'EMERGENCY', [useCase]);
  const className = useMemo(
    () =>
      isCarrierExempt
        ? 'carrier-exemption-alert'
        : isEmergency
        ? 'emergency-alert'
        : '',
    [isCarrierExempt, isEmergency]
  );
  const text = useMemo(
    () =>
      isCarrierExempt
        ? '<p>The Use Case you selected is only intended for those CSPs that have an <strong>existing exemption agreement</strong> with MNOs. Proceeding without having an existing agreement may result in the Campaign being <strong>rejected.</strong> </p>'
        : isEmergency
        ? emergencyAlertText
        : '',
    [emergencyAlertText, isCarrierExempt, isEmergency]
  );

  return (
    <Dialog
      data-testid="campaignRegisterFormDialog"
      id="successModal"
      className={`success-modal ${className}`}
      fullWidth
      open={open}
      maxWidth="xs"
    >
      <DialogContent className={`success-content-blk text-center`}>
        <div className="paragraph">{parse(text)}</div>
        <ul className="list-inline footer">
          {isCarrierExempt && (
            <li>
              <a
                data-testid="campaignRegisterFormDialogCancelButton"
                className="secondary-btn"
                onClick={onClose}
              >
                Cancel
              </a>
            </li>
          )}
          <li>
            <a
              data-testid="campaignRegisterFormDialogOkButton"
              className="primary-btn"
              onClick={onSubmit}
            >
              {isCarrierExempt ? 'Proceed' : 'OK'}
            </a>
          </li>
        </ul>
      </DialogContent>
    </Dialog>
  );
};

export default UseCaseAlertModal;
